import { render } from "./PageMoneyLineAtxStrategy.vue?vue&type=template&id=5b510e66"
import script from "./PageMoneyLineAtxStrategy.vue?vue&type=script&lang=js"
export * from "./PageMoneyLineAtxStrategy.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__